import { render, staticRenderFns } from "./BDTree.vue?vue&type=template&id=0b21827b&scoped=true&"
import script from "./BDTree.vue?vue&type=script&lang=js&"
export * from "./BDTree.vue?vue&type=script&lang=js&"
import style0 from "./BDTree.vue?vue&type=style&index=0&id=0b21827b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21827b",
  null
  
)

export default component.exports